@use "../../config/defaults.module.scss" as defaults;

.sidebar {
	flex: 0 0 300px;
	// Firefox needs this for user-email break word to work inside flex items.
	max-width: 300px;
	padding-left: 16px;

	@media screen and (max-width: defaults.$mediumBreakpoint) {
		max-width: none;
		padding-right: 16px;
		overflow: hidden;
	}
}

.needsBrandInsightsModal {
	display: flex;
	flex-direction: column;
	justify-content: center;
	background: linear-gradient(to bottom, rgba(166, 30, 105, 0.25) 0%, #fff 50%, #fff 100%);
	max-width: 512px !important;
	padding: 40px 40px 16px !important;
	border-radius: 24px !important;

	.previewImage {
		border-radius: 12px;
		width: 432px;
		height: 244px;
		object-fit: cover;
		margin: 0 auto;
		box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
	}

	.nowAvailable {
		// slate 500.
		@apply yst-text-xs yst-font-medium yst-text-slate-500;
		text-align: center;
		margin-top: 16px;

		img {
			@apply yst-inline-block yst-mr-1;
			width: 24px;
			height: 24px;
			vertical-align: middle;
			position: relative;
			top: -1px;
		}

		font-family: BlinkMacSystemFont,
		Segoe UI,
		sans-serif,
		Apple Color Emoji,
		Segoe UI Emoji,
		Segoe UI Symbol,
		Noto Color Emoji;
	}

	.description {
		width: 70%;
		margin: 16px auto 0 auto;
		text-align: center;
	}

	.upsellButton {
		@apply yst-mt-2 yst-w-full;

		gap: 8px;
	}

	.closeButton {
		@apply yst-mt-4 yst-w-full;
	}
}